import { createSlice } from "@reduxjs/toolkit";

const initialCompanyKpisState = {
  companyKpis: {
    count: 0,
    list: [],
    loading: false,
    errorMessage: null,
  },
};

const companyKpis = createSlice({
  name: "companyKpis",
  initialState: initialCompanyKpisState,
  reducers: {
    getCompanyKpisRequest(state) {
      state.companyKpis.loading = true;
    },
    getCompanyKpisSuccess(state, action) {
      state.companyKpis.list = action.payload.data;
      state.companyKpis.count = action.payload.count;
      state.companyKpis.errorMessage = "";
      state.companyKpis.loading = false;
    },
    getCompanyKpisFailed(state, action) {
      state.companyKpis.list = [];
      state.companyKpis.count = 0;
      state.companyKpis.errorMessage = action.payload.errorMessage;
      state.companyKpis.loading = false;
    },
  },
});

export const companyKpisActions = companyKpis.actions;
export default companyKpis.reducer;
